import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const updateCampaign = ({ churchId, campaignId, campaignData }) => {
  return axios.patch(
    `/churches/${churchId}/campaigns/${campaignId}`,
    campaignData
  );
};

export const useUpdateCampaign = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("campaigns-paginated");

      setNotification({
        type: "success",
        message: "Campaign updated successfully!"
      });
    },
    ...config,
    mutationFn: updateCampaign
  });
};
